import { computed, Injectable, signal } from '@angular/core';
import { Session } from '../../models';

const STORAGE_KEY = 'alia_session';

interface PersistedSession {
  rol: string;
  tenantId: string;
  nombreCompleto: string;
}

@Injectable({ providedIn: 'root' })
export class SessionService {
  private readonly _session = signal<Session | null>(null);

  readonly session = this._session.asReadonly();
  readonly isAuthenticated = computed(() => this._session() !== null);

  set(session: Session): void {
    this._session.set(session);
    const persisted: PersistedSession = {
      rol: session.rol,
      tenantId: session.tenantId,
      nombreCompleto: session.nombreCompleto,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(persisted));
  }

  updateTokens(accessToken: string, expiresIn: number): void {
    const current = this._session();
    if (current) {
      this._session.set({ ...current, accessToken, expiresIn });
    }
  }

  restoreFromStorage(accessToken: string, expiresIn: number): boolean {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    try {
      const { rol, tenantId, nombreCompleto }: PersistedSession = JSON.parse(raw);
      this._session.set({ accessToken, expiresIn, rol, tenantId, nombreCompleto });
      return true;
    } catch {
      return false;
    }
  }

  clear(): void {
    this._session.set(null);
    localStorage.removeItem(STORAGE_KEY);
  }
}
